export const nowIso = () => new Date().toISOString();
